import type { AxiosResponse } from 'axios'
import type { Country } from 'types'

export enum ActionType {
  GET_COUNTRIES = 'GET_COUNTRIES',
  SET_COUNTRIES = 'SET_COUNTRIES',
}

export type GetCountriesResponse = AxiosResponse<{ data: Country[] }>
